import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import Modal from "react-modal";
import { useEffect, useState } from "react";
import { closeModal, openModal } from "../../redux/slices/modalSlice";
import iconImage from "../../assets/images/user-image.png";
import { t } from "i18next";
import checkbox from "../../assets/images/icons8-checkbox-48.png";
import check from "../../assets/images/icons8-check-48.png";
import { Link } from "react-router-dom";
import ShareChoiceModal from "../Common/ShareChoiceModal";
import { getContactId } from "../../tools/utils";
import { editConnection, removeCertWatchRequest } from "../../redux/thunks/certConnectThunks";
import { getContactDesignations } from "../../redux/thunks/designationThunks";
import { Loader } from "../Loader";
import moment from "moment";
import { setConnection } from "../../redux/slices/certConnectSlice";

Modal.setAppElement("#root");

const ConnectionModal = () => {
  const dispatch = useDispatch<AppDispatch>();
  const contactId = getContactId();

  const { connectionModal, editCertConnectModal } = useSelector(
    (state: RootState) => state.modals
  );

  const { connection, loading: connectionLoading } = useSelector(
    (state: RootState) => state.certConnect
  );

  const { contactDesignations ,loading: contactDesigLoading,error: contactDesigError } = useSelector(
    (state: RootState) => state.designation
  );

  const [editConnectionForm, setEditConnectionForm] = useState({
    available: false,
    note: "",
  });

  const [editLoading, setEditLoading] = useState(false);

  useEffect(() => {
    if (connection) {
      dispatch(getContactDesignations(connection.ContactId || ""));
      setEditConnectionForm({
        available: connection.Available || false,
        note: connection.Note || "",
      });
    }
  }, [connection]);

  if (!connectionModal && !editCertConnectModal) return null;

  const handleSave = async () => {
    if (!connection) return;
    try {
      setEditLoading(true);
      await dispatch(
        editConnection({
          id: connection.CertWatchRequestId,
          Available: editConnectionForm.available,
          Note: editConnectionForm.note || "",
        })
      );
      dispatch(
      setConnection({
        ...connection,        
        Available: editConnectionForm.available,
        Note: editConnectionForm.note || "",
      })
    );
      dispatch(closeModal("editCertConnectModal"));
    } catch (error) {
      console.error(error);
    } finally {
      setEditLoading(false);
    }
  };

const handleRemove = async (id?: string, contactId?: string) => {
  if (!id || !contactId) return; 
  try {
    await dispatch(removeCertWatchRequest({ Id: id, ContactId: contactId }));
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(closeModal("connectionModal")); 
  }
};


const certDate = connection?.CertExpirationDate
  ? new Date(connection.CertExpirationDate).toISOString().split("T")[0] 
  : "—";


const expiryDate = connection?.CertExpirationDate
  ? new Date(connection.CertExpirationDate)
  : null;

let expiryStyle ;

if (expiryDate) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const daysLeft = Math.floor(
    (expiryDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)
  );

  const isCritical = daysLeft >= 0 && daysLeft <= 30;
  const isWarning = daysLeft > 30 && daysLeft <= 365;

  expiryStyle = {
    backgroundColor: isCritical ? "yellow" : isWarning ? "yellow" : "transparent",
    border: isCritical ? "2px solid red" : "none",
  color: "black",
  padding: "2px 6px",
  borderRadius:  "4px" ,
  };
}


return(
  <>
  {connectionModal && (

    <Modal
      isOpen={connectionModal}
      onRequestClose={() => dispatch(closeModal("connectionModal"))}
      shouldCloseOnOverlayClick={false}
      contentLabel="Candidate Detail"
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 201,
        },
        content: {
          position: "relative",
          width: "90%",
          maxWidth: "1200px",
          height: "auto",
          maxHeight: "90vh",
          overflowY: "auto",
          padding: "30px",
          borderRadius: "12px",
          inset: "unset",
          backgroundColor: "#ffffff",
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
          border: "none",
          fontFamily: "Segoe UI, sans-serif",
        },
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: "20px",
            fontWeight: 600,
            color: "#222",
          }}
        >
          {connection?.ContactName}
        </h2>
        <button
          onClick={() => dispatch(closeModal("connectionModal"))}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "22px",
            fontWeight: "bold",
            cursor: "pointer",
            color: "#888",
            lineHeight: 1,
          }}
          aria-label="Close modal"
        >
          ×
        </button>
      </div>

      <div className="cco_accordion_item_body" style={{ display: "block" }}>
        <div>
          <table className="cco_table cco_table_1">
            <tbody className="cco_table_body">
              <tr className="cco_table_row">
                <td className="cco_table_cell cco_table_cell_small">
                  <div className="connection-modal-photo">
                    <img
                      src={connection?.ContactProfilePic || iconImage}
                      alt="Profile"
                    />
                  </div>
                </td>

                <td className="cco_table_cell cco_table_cell_medium">
                  <div className="cco_blurb cco_blurb_0">
                    <div className="cco_blurb_label">
                      {t("MyCCOPro.SearchCandidate.name")}
                    </div>
                    <div className="cco_blurb_value">
                      <strong>{connection?.ContactName}</strong>
                    </div>
                  </div>

                  <div className="cco_blurb cco_blurb_0">
                    <div className="cco_blurb_label">
                      {t("MyCCOPro.SearchCandidate.ccoId")}
                    </div>
                    <div className="cco_blurb_value">
                      <strong>{connection?.ContactCCOID || "—"}</strong>
                    </div>
                  </div>

                  {connection?.StatusReason === "Pending" ||
                  connection?.CandidateAccessControl === "Locked" ||
                  connection?.IsPhotoApproved === false ||
                  connection?.ShowContactInfo === false ? null : (
                    <>
                      <div className="cco_blurb cco_blurb_0">
                        <div className="cco_blurb_label">
                          {t("MyCCOPro.SearchCandidate.email")}
                        </div>
                        <div className="cco_blurb_value">
                          <strong>{connection?.PersonalEmail}</strong>
                        </div>
                      </div>

                      <div className="cco_blurb cco_blurb_0">
                        <div className="cco_blurb_label">
                          {t("MyCCOPro.SearchCandidate.mobile")}
                        </div>
                        <div className="cco_blurb_value">
                          <strong>
                            {connection?.MobilePhone || "—"}
                          </strong>
                        </div>
                      </div>

                      <div className="cco_blurb cco_blurb_0">
                        <div className="cco_blurb_label">
                          {t("MyCCOPro.SearchCandidate.available")}
                        </div>
                        <div className="cco_blurb_value">
                          {connection?.Available ? (
                            <img
                              src={check}
                              alt="Available"
                              style={{ width: "25px", height: "25px" }}
                            />
                          ) : (
                            <img
                              src={checkbox}
                              alt="Not Available"
                              style={{ width: "21px", height: "21px" }}
                            />
                          )}
                        </div>
                      </div>

                      <div className="cco_blurb cco_blurb_0">
                        <div className="cco_blurb_label">
                          {t("MyCCOPro.SearchCandidate.note")}
                        </div>
                        <div className="cco_blurb_value">
                          <strong>{connection?.Note || "—"}</strong>
                        </div>
                      </div>
                    </>
                  )}
                </td>

                     <td
               className="cco_table_cell cco_table_cell_small"
               style={{ verticalAlign: "top" }}
             >
               {connection?.StatusReason === "Approved" &&
               connection?.CandidateAccessControl === "Locked" ? (
                 <div
                   style={{
                     marginTop: "10px",
                     fontWeight: "bold",
                     color: "#c53030",
                     textAlign: "center",
                   }}
                 >
                   {t("MyCCOPro.SearchCandidate.accounterror")}
                 </div>
               ) :  connection?.StatusReason === "Pending" ? (
                 <div
                   style={{
                     marginTop: "10px",
                     fontWeight: "bold",
                     color: "#c67b05",
                   }}
                 >
                   {t("MyCCOPro.SearchCandidate.pendingError")}
                 </div>
               ) :  connection?.StatusReason ===
                   "Approved" &&
                 connection?.CandidateAccessControl !== "Locked" &&
                 connection?.IsPhotoApproved === false ? (
                 <div
                   style={{
                     marginTop: "10px",
                     fontWeight: "bold",
                     color: "#c67b05",
                     textAlign: "center",
                   }}
                 >
                   {t("MyCCOPro.SearchCandidate.IsApprovedPhotoError")}
                 </div>
               ) : (
                
    <>
  <table
    style={{
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "10px",
    }}
  >
    <thead>
      <tr style={{ fontWeight: "bold" }}>
        <th style={{ textAlign: "left", paddingBottom: "4px" }}>
          {t("MyCCOPro.SearchCandidate.designation")}
        </th>
        <th style={{ textAlign: "center", paddingBottom: "4px" }}>
          {t("MyCCOPro.SearchCandidate.status")}
        </th>
        <th style={{ textAlign: "right", paddingBottom: "4px" }}>
          {t("MyCCOPro.SearchCandidate.expiration")}
        </th>
      </tr>
    </thead>

    <tbody>
      {contactDesigLoading ? (
        <tr>
          <td colSpan={3}>
            <Loader />
          </td>
        </tr>
      ) : contactDesigError ? (
        <tr>
          <td colSpan={3} style={{ color: "red" }}>
            {contactDesigError}
          </td>
        </tr>
      ) : Array.isArray(contactDesignations) &&
        contactDesignations.length > 0 ? (
        [...contactDesignations]
          .sort((a, b) => a.Code.localeCompare(b.Code))
          .map((designator, i) => {
            const expiryMoment = designator.CertExpirationDate
              ? moment(designator.CertExpirationDate).startOf("day")
              : null;

            const expirationDate = expiryMoment
              ? expiryMoment.format("YYYY-MM-DD")
              : "—";

            const today = moment().startOf("day");

            const daysLeft = expiryMoment
              ? expiryMoment.diff(today, "days")
              : null;

            const isCritical =
              daysLeft !== null && daysLeft >= 0 && daysLeft <= 30;

            const isWarning =
              daysLeft !== null && daysLeft > 30 && daysLeft <= 365;

            const expirationStyle = {
              backgroundColor:
                isCritical || isWarning ? "yellow" : "transparent",
              border: isCritical ? "2px solid red" : "none",
              fontWeight:
                isCritical || isWarning ? "bold" : "normal",
              padding: "1px",
              borderRadius: "5px",
              color: "#000000DE",
              display: "inline-block",
              whiteSpace: "nowrap",
            };

            return (
              <tr key={i} style={{ height: "28px" }}>
                <td style={{ textAlign: "left" }}>
                  {designator.Code}
                </td>

                <td style={{ textAlign: "center" }}>
                  {t(
                    `MyCCOPro.SearchCandidate.Statuses.${designator.Status}`,
                    { defaultValue: designator.Status }
                  )}
                </td>

                <td style={{ textAlign: "right" }}>
                  <span style={expirationStyle}>
                    {expirationDate}
                  </span>
                </td>
              </tr>
            );
          })
      ) : (
        <tr>
          <td style={{ textAlign: "left" }}>N/A</td>
          <td style={{ textAlign: "center" }}>N/A</td>
          <td style={{ textAlign: "right" }}>N/A</td>
        </tr>
      )}
    </tbody>
  </table>
</>

               )}
             </td>
              </tr>
            </tbody>
          </table>

          {/* Footer menu */}
          <ul className="cco_menu cco_menu_3">
            {connection?.StatusReason === "Pending" ||
            connection?.IsPhotoApproved === false ||
            connection?.CandidateAccessControl === "Locked" ? null : (
              <li className="cco_menu_item">
                <Link
                  to="#"
                  onClick={async () => {
                    setEditConnectionForm({
                      note: connection?.Note || "",
                      available: connection?.Available || false,
                    });
                    dispatch(openModal("editCertConnectModal"));
                  }}
                  style={{ cursor: "pointer", textDecoration: "none" }}
                >
                  {t("MyCCOPro.SearchCandidate.edit")}
                </Link>
              </li>
            )}
            <li className="cco_menu_item">
  <Link
    to="#"
    onClick={(e) => {
      e.preventDefault();
      handleRemove(connection?.CertWatchRequestId, contactId);
    }}
    style={{ cursor: "pointer", textDecoration: "none" }}
  >
    {t("MyCCOPro.SearchCandidate.remove")}
  </Link>
</li>

            {connection?.ShowSharebutton === true &&
            connection?.StatusReason === "Approved" &&
            connection?.IsPhotoApproved !== false &&
            connection?.CandidateAccessControl !== "Locked" &&
            connection?.MyCCODesignationDetails?.length !== 0 ? (
              <ShareChoiceModal
                CCOID={connection?.ContactCCOID ?? ''}
                Name={connection?.ContactName ?? ''}
                designations={contactDesignations ?? []}
              />
            ) : null}
          </ul>
        </div>
      </div>
    </Modal>
          )}
   {editCertConnectModal && (
   <Modal
     isOpen={true}
   onRequestClose={() => dispatch(closeModal("editCertConnectModal"))}
     shouldCloseOnOverlayClick={false}
     contentLabel="Edit Note and Availability"
     style={{
       overlay: {
         backgroundColor: 'rgba(0, 0, 0, 0.4)',
         display: 'flex',
         alignItems: 'center',
         justifyContent: 'center',
         zIndex: 1001,
       },
       content: {
         position: 'relative',
         width: '480px',
         maxWidth: '95%',
         padding: '30px',
         borderRadius: '12px',
         inset: 'unset',
         backgroundColor: '#ffffff',
         boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
         border: 'none',
         fontFamily: 'Segoe UI, sans-serif',
       },
     }}
   >
     {/* Header */}
     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
       <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 600, color: '#222' }}>
        {t('MyCCOPro.SearchCandidate.editNoteAvailability')}
       </h2>
       <button
         onClick={()=>dispatch(closeModal("editCertConnectModal"))}
         style={{
           background: 'transparent',
           border: 'none',
           fontSize: '22px',
           fontWeight: 'bold',
           cursor: 'pointer',
           color: '#888',
           lineHeight: 1,
         }}
         aria-label="Close modal"
       >
         ×
       </button>
     </div>
   
     {/* Body */}
     <div style={{ marginTop: '24px' }}>
       <div style={{ marginBottom: '20px' }}>
         <label style={{ fontSize: '15px', fontWeight: '500', color: '#444' }}>
           <input
             type="checkbox"
             checked={editConnectionForm.available}
             onChange={(e) => setEditConnectionForm({ ...editConnectionForm, available: e.target.checked })}
             style={{ marginRight: '10px', transform: 'scale(1.2)' }}
           />
          {t('MyCCOPro.SearchCandidate.available')}
         </label>
       </div>
   
       <div>
         <label style={{ fontSize: '15px', fontWeight: '500', color: '#444', display: 'block' }}>
            {t('MyCCOPro.SearchCandidate.note')}
         </label>
         <textarea
           value={editConnectionForm.note}
           onChange={(e) => setEditConnectionForm({ ...editConnectionForm, note: e.target.value })}
           style={{
             width: '100%',
             minHeight: '110px',
             marginTop: '8px',
             padding: '12px',
             borderRadius: '8px',
             border: '1px solid #ccc',
             fontSize: '14px',
             lineHeight: '1.5',
             resize: 'vertical',
           }}
         />
       </div>
     </div>
   
     {/* Footer */}
     <div
       style={{
         display: 'flex',
         justifyContent: 'flex-end',
         marginTop: '28px',
         gap: '12px',
       }}
     >
       <button
         onClick={()=>dispatch(closeModal("editCertConnectModal"))}
         style={{
           padding: '10px 18px',
           backgroundColor: '#f3f3f3',
           color: '#333',
           border: '1px solid #ddd',
           borderRadius: '6px',
           cursor: 'pointer',
           fontWeight: 500,
         }}
       >
         {t('MyCCOPro.SearchCandidate.cancel')}
       </button>
       <button
         onClick={handleSave}
         disabled={editLoading}
         style={{
           padding: '10px 18px',
           backgroundColor: editLoading? '#b57a28' : '#c67b05',
           color: 'white',
           border: 'none',
           borderRadius: '6px',
           cursor: editLoading ? 'not-allowed' : 'pointer',
           fontWeight: 500,
           minWidth: '90px',
         }}
       >
          {editLoading ? t('MyCCOPro.SearchCandidate.saving') : t('MyCCOPro.SearchCandidate.save')}
       </button>
     </div>
   </Modal>  
   )} 
   </>
  );
  
};
export default ConnectionModal;
